import { render, staticRenderFns } from "./behavioralAssessment.vue?vue&type=template&id=0b2700b2&scoped=true"
import script from "./behavioralAssessment.vue?vue&type=script&lang=js"
export * from "./behavioralAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2700b2",
  null
  
)

export default component.exports